import keycloak from '@core/auth/keycloak';

export interface UniversalUser {
  id: string;
  email?: string;
  phone?: string;
  provider: 'oauth' | 'phone';
  firebase_uid?: string;
}

export async function getCurrentUser(): Promise<UniversalUser | null> {
  if (!keycloak.authenticated || !keycloak.tokenParsed) return null;
  const p = keycloak.tokenParsed as Record<string, unknown>;
  const sub = typeof p.sub === 'string' ? p.sub : '';
  if (!sub) return null;
  return {
    id: sub,
    email: typeof p.email === 'string' ? p.email : undefined,
    provider: 'oauth',
  };
}

export async function getCurrentUserId(): Promise<string | null> {
  const u = await getCurrentUser();
  return u?.id ?? null;
}
